import React, { useEffect, useState } from 'react';
import { adminApi } from '../utils/api';
import { Card, Badge, Btn, Input, Select, Modal, PageHeader, fmtDate } from '../components/UI';

const BUILT_IN_META = {
  modern:           { name: 'Modern',          color: '#EF1D28', category: 'Professional' },
  classic:          { name: 'Classic',          color: '#1F2937', category: 'Professional' },
  executive:        { name: 'Executive',        color: '#FB923C', category: 'Executive'    },
  minimal:          { name: 'Minimal',          color: '#059669', category: 'Minimal'      },
  creative:         { name: 'Creative',         color: '#DC2626', category: 'Creative'     },
  tech:             { name: 'Tech',             color: '#0891B2', category: 'Tech'         },
  elegant:          { name: 'Elegant',          color: '#B45309', category: 'Elegant'      },
  corporate:        { name: 'Corporate',        color: '#1E3A5F', category: 'Professional' },
  blue_corporate:   { name: 'Blue Corporate',   color: '#1B3A6B', category: 'Professional' },
  navy_timeline:    { name: 'Navy Timeline',    color: '#2C3E50', category: 'Professional' },
  crimson:          { name: 'Crimson',          color: '#7B1C1C', category: 'Professional' },
  harvard_standard: { name: 'Harvard Standard', color: '#111827', category: 'Professional' },
  blue_analyst:     { name: 'Blue Analyst',     color: '#1D6FD6', category: 'Professional' },
  russian_classic:  { name: 'Russian Classic',  color: '#374151', category: 'Professional' },
  gregory_sidebar:  { name: 'Gregory Sidebar',  color: '#1B2A4A', category: 'Professional' },
  slate_sidebar:    { name: 'Slate Sidebar',    color: '#334155', category: 'Professional' },
  mono_pro:         { name: 'Mono Pro',         color: '#111827', category: 'Minimal'      },
  ivory_serif:      { name: 'Ivory Serif',      color: '#7C6A46', category: 'Elegant'      },
  teal_banner:      { name: 'Teal Banner',      color: '#0F766E', category: 'Creative'     },
  swiss_grid:       { name: 'Swiss Grid',       color: '#B91C1C', category: 'Minimal'      },
  amber_executive:  { name: 'Amber Executive',  color: '#B45309', category: 'Executive'    },
  violet_sidebar:   { name: 'Violet Sidebar',   color: '#5B21B6', category: 'Creative'     },
  bold_stripe:      { name: 'Bold Stripe',      color: '#0369A1', category: 'Professional' },
  rose_gold:        { name: 'Rose Gold',        color: '#9F3054', category: 'Elegant'      },
  forest_pro:       { name: 'Forest Pro',       color: '#166534', category: 'Minimal'      },
  sky_pro:          { name: 'Sky Pro',          color: '#0284C7', category: 'Professional' },
  charcoal_split:   { name: 'Charcoal Split',   color: '#1E293B', category: 'Professional' },
  terracotta:       { name: 'Terracotta',       color: '#B54A2B', category: 'Elegant'      },
  startup_clean:    { name: 'Startup',          color: '#6366F1', category: 'Tech'         },
  champagne:        { name: 'Champagne',        color: '#A37E2C', category: 'Elegant'      },
  editorial:        { name: 'Editorial',        color: '#1C1917', category: 'Elegant'      },
  sage:             { name: 'Sage',             color: '#52796F', category: 'Minimal'      },
  graphite:         { name: 'Graphite',         color: '#FACC15', category: 'Professional' },
  med_pro_blue:     { name: 'Med Pro Blue',     color: '#1E4D8C', category: 'Medical'      },
  clinical_teal:    { name: 'Clinical Teal',    color: '#0F766E', category: 'Medical'      },
  nurse_rx:         { name: 'Nurse Rx',         color: '#B91C1C', category: 'Medical'      },
  healthcare_pro:   { name: 'Healthcare Pro',   color: '#0C2340', category: 'Medical'      },
  critical_care:    { name: 'Critical Care',    color: '#0C2340', category: 'Medical'      },
  realty_pro:       { name: 'Realty Pro',       color: '#1C3A5E', category: 'Real Estate'  },
  estate_sidebar:   { name: 'Estate Sidebar',   color: '#2D6A4F', category: 'Real Estate'  },
  luxury_broker:    { name: 'Luxury Broker',    color: '#A07830', category: 'Real Estate'  },
  re_corporate:     { name: 'RE Corporate',     color: '#162032', category: 'Real Estate'  },
  property_exec:    { name: 'Property Exec',    color: '#162032', category: 'Real Estate'  },
  shield_pro:       { name: 'Shield Pro',       color: '#1B3A6B', category: 'Security'     },
  patrol_blue:      { name: 'Patrol Blue',      color: '#0D2461', category: 'Security'     },
  sentinel_dark:    { name: 'Sentinel Dark',    color: '#0A1628', category: 'Security'     },
  guardian_grid:    { name: 'Guardian Grid',    color: '#1E3A1E', category: 'Security'     },
  tactical_clean:   { name: 'Tactical Clean',   color: '#4A5C2A', category: 'Security'     },
  exec_suite:       { name: 'Exec Suite',       color: '#1A2E4A', category: 'Business'     },
  boardroom:        { name: 'Boardroom',        color: '#14213D', category: 'Business'     },
  bizdev_pro:       { name: 'BizDev Pro',       color: '#1D4ED8', category: 'Business'     },
  strategy_blue:    { name: 'Strategy Blue',    color: '#0039A6', category: 'Business'     },
  c_suite:          { name: 'C-Suite',          color: '#0F1F3D', category: 'Business'          },
  bloom_sidebar:    { name: 'Bloom Sidebar',    color: '#BE185D', category: 'Beauty & Wellness' },
  salon_chic:       { name: 'Salon Chic',       color: '#C9A84C', category: 'Beauty & Wellness' },
  spa_zen:          { name: 'Spa Zen',          color: '#4A7C59', category: 'Beauty & Wellness' },
  glow_pro:         { name: 'Glow Pro',         color: '#C2410C', category: 'Beauty & Wellness' },
  beauty_badge:     { name: 'Beauty Badge',     color: '#9D4E7B', category: 'Beauty & Wellness' },
};
const BUILT_IN = Object.keys(BUILT_IN_META);

const TemplateForm = ({ initial = {}, onSave, onClose, isNew }) => {
  const [form, setForm] = useState({
    id: '', name: '', desc: '', color: '#EF1D28',
    free: true, active: true, category: 'professional', ...initial,
  });
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const submit = async () => {
    setError('');
    if (!form.name) return setError('Name is required');
    if (isNew && !form.id) return setError('Template ID is required');
    setSaving(true);
    try { await onSave({ ...form, free: true }); onClose(); }
    catch (e) { setError(e.message); }
    finally { setSaving(false); }
  };

  return (
    <Modal title={isNew ? 'Add New Template' : `Edit: ${initial.name}`} onClose={onClose}>
      {error && <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', color: '#DC2626', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 13 }}>{error}</div>}
      {isNew && <Input label="Template ID (unique, no spaces)" value={form.id} onChange={v => set('id', v.toLowerCase().replace(/\s+/g, '-'))} placeholder="e.g. modern-blue" />}
      <Input label="Display Name" value={form.name} onChange={v => set('name', v)} placeholder="e.g. Modern Blue" />
      <Input label="Description" value={form.desc} onChange={v => set('desc', v)} placeholder="Brief description of the template" />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <div>
          <label style={{ display: 'block', color: '#64748B', fontSize: 12, fontWeight: 600, marginBottom: 5 }}>Accent Color</label>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input type="color" value={form.color} onChange={e => set('color', e.target.value)}
              style={{ width: 40, height: 36, border: '1px solid #E2E8F0', borderRadius: 6, cursor: 'pointer', background: '#F8FAFC', padding: 2 }} />
            <input value={form.color} onChange={e => set('color', e.target.value)}
              style={{ flex: 1, background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: 7, padding: '8px 12px', color: '#0F172A', fontSize: 13, outline: 'none' }} />
          </div>
        </div>
        <Select label="Category" value={form.category} onChange={v => set('category', v)}
          options={[['professional','Professional'],['creative','Creative'],['academic','Academic'],['minimal','Minimal']]} />
      </div>
      <div style={{ display: 'flex', gap: 20, marginBottom: 16 }}>
        <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer', color: '#64748B', fontSize: 13 }}>
          <input type="checkbox" checked readOnly disabled style={{ width: 15, height: 15, accentColor: '#EF1D28' }} />
          Available on Free plan
        </label>
        <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer', color: '#64748B', fontSize: 13 }}>
          <input type="checkbox" checked={form.active} onChange={e => set('active', e.target.checked)} style={{ width: 15, height: 15, accentColor: '#059669' }} />
          Active (visible to users)
        </label>
      </div>
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <Btn color="ghost" onClick={onClose}>Cancel</Btn>
        <Btn color="blue" onClick={submit} disabled={saving}>{saving ? 'Saving...' : 'Save Template'}</Btn>
      </div>
    </Modal>
  );
};

export const TemplatesPage = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [editing, setEditing]     = useState(null);
  const [creating, setCreating]   = useState(false);

  const load = () => {
    setLoading(true);
    adminApi.getTemplates().then(setTemplates).catch(console.error).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const handleCreate = async (form) => {
    const tmpl = await adminApi.createTemplate(form);
    setTemplates(prev => [tmpl, ...prev]);
  };

  const handleUpdate = async (form) => {
    const tmpl = await adminApi.updateTemplate(form.id, form);
    setTemplates(prev => prev.map(t => t.id === form.id ? tmpl : t));
  };

  const toggleActive = async (tmpl) => {
    try {
      const updated = await adminApi.updateTemplate(tmpl.id, { active: !tmpl.active });
      setTemplates(prev => prev.map(t => t.id === tmpl.id ? updated : t));
    } catch (e) { alert(e.message); }
  };

  const del = async (id) => {
    if (!window.confirm('Delete this custom template?')) return;
    await adminApi.deleteTemplate(id);
    setTemplates(prev => prev.filter(t => t.id !== id));
  };

  // Show both built-in (with DB override if exists) and DB-only
  const dbIds = templates.map(t => t.id);
  const builtInNotInDB = BUILT_IN.filter(id => !dbIds.includes(id));

  return (
    <div>
      <PageHeader
        title="Templates"
        subtitle="Manage resume templates. Every template is available on the free plan."
        action={<Btn color="blue" onClick={() => setCreating(true)}>+ Add Template</Btn>}
      />

      {/* Built-in templates */}
      <div style={{ color: '#64748B', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>
        Built-in Templates ({BUILT_IN.length})
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 24 }}>
        {BUILT_IN.map(id => {
          const dbEntry  = templates.find(t => t.id === id);
          const meta     = BUILT_IN_META[id] || {};
          const isActive = dbEntry ? dbEntry.active : true;
          const color    = dbEntry?.color || meta.color || '#EF1D28';
          const dispName = dbEntry?.name  || meta.name  || id;
          const category = dbEntry?.category || meta.category || 'Professional';
          return (
            <Card key={id} style={{ padding: 16, opacity: isActive ? 1 : 0.5 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ width: 12, height: 32, background: color, borderRadius: 3 }} />
                  <div>
                    <div style={{ color: '#0F172A', fontWeight: 700, fontSize: 14 }}>{dispName}</div>
                    <div style={{ fontSize: 11, color: '#64748B' }}>Built-in · {category}</div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
                  <Badge color="green">Free</Badge>
                  <Badge color={isActive ? 'blue' : 'gray'}>{isActive ? 'Active' : 'Hidden'}</Badge>
                </div>
              </div>
              {dbEntry && (
                <div style={{ fontSize: 11, color: '#64748B', marginBottom: 8 }}>
                  Usage: {dbEntry.usageCount || 0} times
                </div>
              )}
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {dbEntry ? (
                  <>
                    <Btn size="sm" color="ghost" onClick={() => toggleActive(dbEntry)}>{isActive ? 'Hide' : 'Show'}</Btn>
                    <Btn size="sm" color="ghost" onClick={() => setEditing(dbEntry)}>Edit</Btn>
                  </>
                ) : (
                  <Btn size="sm" color="ghost" onClick={() => setCreating(true)} style={{ opacity: 0.6 }}>Override in DB</Btn>
                )}
              </div>
            </Card>
          );
        })}
      </div>

      {/* Custom DB templates */}
      {templates.filter(t => !BUILT_IN.includes(t.id)).length > 0 && (
        <>
          <div style={{ color: '#64748B', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>
            Custom Templates ({templates.filter(t => !BUILT_IN.includes(t.id)).length})
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginBottom: 24 }}>
            {templates.filter(t => !BUILT_IN.includes(t.id)).map(tmpl => (
              <Card key={tmpl.id} style={{ padding: 16, opacity: tmpl.active ? 1 : 0.5 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{ width: 12, height: 32, background: tmpl.color, borderRadius: 3 }} />
                    <div>
                      <div style={{ color: '#0F172A', fontWeight: 700, fontSize: 14 }}>{tmpl.name}</div>
                      <div style={{ fontSize: 11, color: '#64748B' }}>{tmpl.id}</div>
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 5 }}>
                    <Badge color="green">Free</Badge>
                    <Badge color={tmpl.active ? 'blue' : 'gray'}>{tmpl.active ? 'Active' : 'Hidden'}</Badge>
                  </div>
                </div>
                {tmpl.desc && <div style={{ fontSize: 12, color: '#64748B', marginBottom: 8 }}>{tmpl.desc}</div>}
                <div style={{ fontSize: 11, color: '#64748B', marginBottom: 10 }}>
                  Category: {tmpl.category} · Usage: {tmpl.usageCount || 0} · Added: {fmtDate(tmpl.createdAt)}
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <Btn size="sm" color="ghost" onClick={() => setEditing(tmpl)}>Edit</Btn>
                  <Btn size="sm" color="ghost" onClick={() => toggleActive(tmpl)}>{tmpl.active ? 'Hide' : 'Show'}</Btn>
                  <Btn size="sm" color="red" onClick={() => del(tmpl.id)}>Delete</Btn>
                </div>
              </Card>
            ))}
          </div>
        </>
      )}

      {creating && <TemplateForm isNew onSave={handleCreate} onClose={() => setCreating(false)} />}
      {editing  && <TemplateForm initial={editing} onSave={handleUpdate} onClose={() => setEditing(null)} />}
    </div>
  );
};
